import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinpimpri() {



  const cardData =
  {
    keyword: 'Mini Bus on Rent in Pimpri Chinchwad',
    heading: 'Amruta Travels: Mini Bus on Rent in Pimpri Chinchwad',
    headingDescription: 'Amruta Travels Pvt. Ltd. provides Mini Bus on Rent in Pimpri Chinchwad, offering a perfect travel solution for groups seeking comfort, safety, and affordability. Whether it’s a corporate trip, school picnic, family function, or outstation tour, our well-maintained mini buses are equipped with plush seating, powerful air conditioning, and ample luggage space to ensure a smooth and enjoyable journey. Driven by professional chauffeurs, each ride is punctual, comfortable, and hassle-free. With services available across Nigdi, Chinchwad, Wakad, Hinjewadi, and Talegaon, Amruta Travels Pvt. Ltd. stands as the most trusted choice for Mini Bus Rental in Pimpri Chinchwad, delivering premium travel experiences for every occasion.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



      "services": [
    {
      "name": "Mini Bus on Rent in Pimpri Chinchwad",
      "description": "Mini Bus on Rent in Pimpri Chinchwad provides reliable and spacious transportation solutions ideal for group travel, corporate events, and family outings. These mini buses come with ample seating, luggage space, and professional drivers to ensure comfortable, timely, and safe journeys across the PCMC region."
    },
    {
      "name": "Mini Bus Hire PCMC",
      "description": "Mini Bus Hire PCMC offers well-maintained mini buses for rent across Pimpri Chinchwad, catering to businesses, tourists, and local groups. With flexible rental options, experienced chauffeurs, and excellent service standards, this option ensures a smooth and enjoyable travel experience."
    },
    {
      "name": "Mini Bus Booking Pimpri",
      "description": "Mini Bus Booking Pimpri allows customers to easily reserve comfortable and well-equipped mini buses for various travel needs. Whether for corporate trips, family tours, or local events, the service ensures convenient booking, transparent pricing, and reliable on-time travel solutions."
    },
    {
      "name": "AC Mini Bus Pimpri",
      "description": "AC Mini Bus Pimpri provides fully air-conditioned buses for a cool and pleasant travel experience. Perfect for Pune’s warm climate, these buses offer comfort and convenience for corporate meetings, airport transfers, and leisure tours, driven by courteous and professional chauffeurs."
    },
    {
      "name": "Non AC Mini Bus Pimpri",
      "description": "Non AC Mini Bus Pimpri offers budget-friendly travel options for local and short-distance group journeys. Despite being non-air-conditioned, these mini buses maintain high standards of cleanliness, comfort, and safety, making them ideal for economical group travel."
    },
    {
      "name": "Luxury Mini Bus Pimpri",
      "description": "Luxury Mini Bus Pimpri delivers a premium travel experience with plush interiors, comfortable seating, and elegant design. Perfect for weddings, VIP events, and corporate use, these buses come with professional drivers and ensure a luxurious and memorable journey."
    },
    {
      "name": "Mini Bus Hire Nigdi",
      "description": "Mini Bus Hire Nigdi caters to the transportation needs of residents and businesses in Nigdi, offering well-maintained vehicles for group trips, events, and office commutes. The service focuses on punctuality, safety, and customer satisfaction."
    },
    {
      "name": "Mini Bus Hire Wakad",
      "description": "Mini Bus Hire Wakad provides efficient and dependable rental services for group travel in and around Wakad. Whether for family trips or corporate outings, the service ensures clean vehicles, professional drivers, and smooth travel experiences."
    },
    {
      "name": "Mini Bus Hire Bhosari",
      "description": "Mini Bus Hire Bhosari specializes in group transport for businesses and residents in Bhosari. With well-kept mini buses and expert drivers, the service guarantees safe, timely, and comfortable rides for all kinds of travel requirements."
    },
    {
      "name": "Mini Bus for Corporate Pimpri",
      "description": "Mini Bus for Corporate Pimpri provides reliable group transport solutions for companies and professionals. These buses are ideal for employee commutes, client visits, and business events, ensuring punctual service and a comfortable journey."
    },
    {
      "name": "Mini Bus for Wedding Pimpri",
      "description": "Mini Bus for Wedding Pimpri offers elegant and well-decorated vehicles for weddings, receptions, and other celebrations. With timely service, courteous drivers, and optional decorations, it ensures smooth transportation for your special day."
    },
    {
      "name": "Mini Bus for School Trip Pimpri",
      "description": "Mini Bus for School Trip Pimpri provides safe and comfortable buses for educational tours and excursions. Each vehicle is well-maintained and driven by experienced chauffeurs trained in handling school transport with care and responsibility."
    },
    {
      "name": "Mini Bus for Outstation Pimpri",
      "description": "Mini Bus for Outstation Pimpri offers reliable long-distance travel for groups heading outside the city. These buses feature spacious seating, luggage capacity, and skilled drivers experienced with intercity routes to ensure smooth outstation travel."
    },
    {
      "name": "Affordable Mini Bus Pimpri",
      "description": "Affordable Mini Bus Pimpri focuses on providing cost-effective group travel options without compromising safety or comfort. Ideal for schools, families, and small companies, the service offers transparent rates and dependable vehicles."
    },
    {
      "name": "Best Mini Bus Rental Pimpri",
      "description": "Best Mini Bus Rental Pimpri stands out for offering top-quality vehicles and professional drivers for all travel purposes. The service combines reliability, comfort, and affordability, making it the preferred choice for local and outstation journeys."
    },
    {
      "name": "Mini Bus Booking Online Pimpri",
      "description": "Mini Bus Booking Online Pimpri enables quick and easy reservations through an online platform. Customers can choose routes, make secure payments, and receive instant confirmations for a seamless and modern booking experience."
    },
    {
      "name": "Mini Bus Hire near Me Pimpri",
      "description": "Mini Bus Hire near Me Pimpri ensures quick access to available mini buses across Pimpri and surrounding areas. The service emphasizes fast response times, flexible rental durations, and comfortable, safe rides for groups of all sizes."
    },
    {
      "name": "Small Bus Hire PCMC",
      "description": "Small Bus Hire PCMC provides compact yet comfortable buses ideal for small groups and short-distance travel in Pimpri Chinchwad. The service guarantees well-maintained vehicles, skilled drivers, and affordable pricing."
    }
  ],
  "tableData": [
    ["Mini Bus on Rent in Pimpri Chinchwad", "Mini Bus Hire PCMC"],
    ["Mini Bus Booking Pimpri", "AC Mini Bus Pimpri"],
    ["Non AC Mini Bus Pimpri", "Luxury Mini Bus Pimpri"],
    ["Mini Bus Hire Nigdi", "Mini Bus Hire Wakad"],
    ["Mini Bus Hire Bhosari", "Mini Bus for Corporate Pimpri"],
    ["Mini Bus for Wedding Pimpri", "Mini Bus for School Trip Pimpri"],
    ["Mini Bus for Outstation Pimpri", "Affordable Mini Bus Pimpri"],
    ["Best Mini Bus Rental Pimpri", "Mini Bus Booking Online Pimpri"],
    ["Mini Bus Hire near Me Pimpri", "Small Bus Hire PCMC"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Mini Bus on Rent in Pimpri Chinchwad",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers reliable and comfortable mini bus rental services in Pimpri Chinchwad, ideal for group outings, corporate trips, and family travel."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Fleet",
    "WhyChoosedescription": "Our mini buses are regularly maintained and sanitized to ensure a safe, clean, and hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy competitive rental rates with no hidden charges—what you see is what you pay."
  },
  {
    "WhyChooseheading": "Customizable Rental Packages",
    "WhyChoosedescription": "We offer flexible rental options—hourly, daily, or long-term—catered to your unique travel requirements."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our trained drivers ensure a smooth, punctual, and courteous service throughout your journey."
  },
  {
    "WhyChooseheading": "24/7 Customer Assistance",
    "WhyChoosedescription": "Our support team is available round-the-clock to help with bookings, route planning, and any travel concerns."
  },
  {
    "WhyChooseheading": "Quick and Easy Booking",
    "WhyChoosedescription": "Book your mini bus easily via phone or online, with timely service across Pimpri Chinchwad and nearby areas."
  },
  {
    "WhyChooseheading": "Trusted Travel Partner",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd is committed to delivering safe, efficient, and enjoyable group travel experiences for every customer."
  }
]






























  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer mini bus rental services in Pimpri Chinchwad?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides mini bus on rent services in Pimpri Chinchwad, great for group travel, tours and events.',
  },
  {
    question: 'How can I book a mini bus in Pimpri Chinchwad with Amruta Travels?',
    answer: 'You can book via our website, mobile app, or by contacting our 24×7 customer support team in Pimpri Chinchwad.',
  },
  {
    question: 'What amenities are available in the mini buses in Pimpri Chinchwad?',
    answer: 'Our mini buses are equipped with comfortable seating, air conditioning, good legroom, and essential safety features for a pleasant journey.',
  },
  {
    question: 'Are the drivers trained and licensed for mini bus rentals in Pimpri Chinchwad?',
    answer: 'Absolutely. All our drivers are professional, experienced, and licensed to drive mini buses in and around Pimpri Chinchwad safely.',
  },
  {
    question: 'Can mini buses be rented for weddings, corporate events, tours and airport transfers in Pimpri Chinchwad?',
    answer: 'Yes, mini buses are available for weddings, corporate functions, sightseeing tours, airport transfers, and other group travel needs in Pimpri Chinchwad.',
  },
  {
    question: 'Is the mini bus hire service available 24×7 in Pimpri Chinchwad?',
    answer: 'Yes, Amruta Travels offers mini bus rental services in Pimpri Chinchwad 24×7 to suit your schedule.',
  },
  {
    question: 'What safety and hygiene measures are followed for mini buses in Pimpri Chinchwad?',
    answer: 'All our mini buses are thoroughly sanitized before every trip, and drivers follow strict hygiene protocols and safety guidelines.',
  },
  {
    question: 'What are the payment options for renting a mini bus in Pimpri Chinchwad?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available throughout the mini bus rental period in Pimpri Chinchwad?',
    answer: 'Yes, our 24×7 customer support team is here to assist you at any time during your rental period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Kulkarni',
    feedback: 'Renting a mini bus from Amruta Travels in Pimpri Chinchwad was smooth and hassle‑free. The bus was clean and the driver courteous.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Mehta',
    feedback: 'Excellent experience! The mini bus was comfortable and arrived on time. Made our group outing in Pimpri Chinchwad so much better.',
    rating: 5,
  },
];



























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus on Rent in Pimpri Chinchwad",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/6.jpg",
  "description": "Book a Mini Bus on Rent in Pimpri Chinchwad with Amruta Travels Pvt. Ltd. offering AC, Non-AC, and Luxury Mini Buses for corporate trips, weddings, school tours, and outstation travel at affordable prices.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "17423"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/mini-bus-on-rent-in-pimpri-chinchwad"
  }
};







  return (
    <div>

<Helmet>
  <title>Mini Bus on Rent in Pimpri Chinchwad | AC & Luxury Bus Hire | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Mini Bus on Rent in Pimpri Chinchwad with Amruta Travels Pvt. Ltd. Choose from AC, Non-AC, and Luxury Mini Buses for corporate, wedding, and outstation trips. Affordable and reliable bus rental service in PCMC."
  />
  <meta
    name="keywords"
    content="Mini Bus on Rent in Pimpri Chinchwad, Mini Bus Hire PCMC, Mini Bus Booking Pimpri, AC Mini Bus Pimpri, Non AC Mini Bus Pimpri, Luxury Mini Bus Pimpri, Mini Bus Hire Nigdi, Mini Bus Hire Wakad, Mini Bus Hire Bhosari, Mini Bus for Corporate Pimpri, Mini Bus for Wedding Pimpri, Mini Bus for School Trip Pimpri, Mini Bus for Outstation Pimpri, Affordable Mini Bus Pimpri, Best Mini Bus Rental Pimpri, Mini Bus Booking Online Pimpri, Mini Bus Hire near Me Pimpri, Small Bus Hire PCMC"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinpimpri;